import $ from 'jquery';

import httpStatus from '../http-status';

export default class {
	constructor() {
		this.host = 'http://cafe.daum.net';

		this.url = {
			bookmark: '/_bookmark',
			tagList: '/_tagList',
			postListByPage: '/_bookmarkListByPaging',
			postListByTagId: '/_bookmarkListByTagId'
		};
	}

	async call(method, url, data) {
		if (data && method.toLowerCase() !== 'get') {
			data = JSON.stringify(data);
		}

		try {
			return await new Promise((resolve, reject) => {
				$.ajax({
					method: method,
					url: url,
					data: data,
					cache: false,
					contentType: 'application/json;charset=utf-8'
				}).done(function (data) {
					if (data.resultCode === httpStatus.OK) {
						resolve(data);
					} else {
						reject({
							status: data.resultCode,
							message: data.resultMessage
						});
					}
				}).fail(function (request) {
					reject({
						status: request.status,
						message: request.statusText
					});
				});
			});
		} catch (e) {
			throw e;
		}
	}

	async add(path) {
		return await this.call('post', this.url.bookmark, { permLink: `${this.host}${path}` });
	}

	async delete(path) {
		return await this.call('delete', this.url.bookmark, { permLink: `${this.host}${path}` });
	}

	async load(path) {
		return await this.call('get', this.url.bookmark, { permLink: `${this.host}${path}` });
	}

	async loadTags() {
		return await this.call('get', this.url.tagList);
	}

	async loadPostsByPage(page, unit) {
		return await this.call('get', this.url.postListByPage, {
			pageNo: page,
			noOfRowsPerPage: unit
		});
	}

	async loadPostsByTagId(tagId) {
		return await this.call('get', this.url.postListByTagId, { tagId: tagId });
	}

	getHost() {
		return this.host;
	}
}
